import { useRef, useState } from 'react';
import { signOut } from 'aws-amplify/auth';
import { hideProcessingNotification, showAppNotification } from '../utils/notifications';
import GreenOneDashboardV2 from '../components/dashboard-v2/GreenOneDashboardV2';
import AppFooter from '../components/ui/AppFooter';
import AppHeader from '../components/ui/AppHeader';

export default function DashboardV2Page({ user }) {
  const logoutPending = useRef(false);
  const [isSignedOut, setIsSignedOut] = useState(false);

  async function handleLogout() {
    if (logoutPending.current) return;
    logoutPending.current = true;

    try {
      await signOut();
    } catch {
      logoutPending.current = false;
      showAppNotification({
        type: 'error',
        message: 'Abmelden fehlgeschlagen. Bitte versuche es erneut.',
      });
      return;
    }

    setIsSignedOut(true);
    hideProcessingNotification();
    localStorage.removeItem('buildingRelationship');
    localStorage.removeItem('emissionsCache');
    sessionStorage.removeItem('greenOneDashboardSkeletonShown');
    sessionStorage.removeItem('datenerhebung_saved');
    window.location.replace('/');
  }

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <AppHeader />
      <div style={{ flex: 1 }}>
        {!isSignedOut && <GreenOneDashboardV2 user={user} onLogout={handleLogout} />}
      </div>
      <AppFooter />
    </div>
  );
}
